import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[solonumerosenteros]',
  providers: [NgModel]
})

/*
* directiva para permitir solo numeros enteros en un input, también 
* maneja la misma restricción para texto pegado
*/
export class SoloNumerosEnterosDirective {

  constructor(private el: ElementRef, private model: NgModel) {
  }

  @Input() solonumerosenteros: boolean;

  // @HostListener('keypress', ['$event']) onKeyPress($event) {
  //   let e = <KeyboardEvent>$event;
    
  //   if (this.solonumerosenteros) {      
  //     // si no es un numero parar el keypress        
  //     //console.log("Directiva keycode: " + e.keyCode);
  //     if (e.keyCode != 13 && (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57))) {
  //       e.preventDefault();
  //     }
  //   }
  // }

  //permitir lo mismo pero en el paste
  @HostListener('paste', ['$event']) onPaste($event) {
    // obtener texto actual
    let textoActual = $event.target.value;
    let textoPegado;
    if (this.solonumerosenteros) {
      //agregar excepcion para internet explorer, ya que dispara
      //un evento DragEvent en lugar de un ClipboardEvent
      let ie = navigator.userAgent.match(/.NET/); // IE 11+
      let oldIE = navigator.userAgent.match(/MSIE/);
      if (ie || oldIE) {
        //obtener el texto pegado del evento dragevent
        textoPegado = (<any>window).clipboardData.getData('Text');
      } else {
        //obtener el texto pegado del clipboardevent
        textoPegado = $event.clipboardData.getData('Text');
      }

      // solo numeros
      let textoFiltrado: String = textoPegado.replace(/[^\d]+/g, '');
      //evitar que se pegue el texto original
      $event.preventDefault();
      // agregar texto filtrado al texto actual
      textoActual += textoFiltrado;
      //verificar que no sobrepase el maxlength
      let maxlength = this.el.nativeElement.attributes['maxlength'];
      if (maxlength != undefined) {
        textoActual = textoActual.substring(0, maxlength.value);
      }

      // actualizar valor actual del texto
      this.model.control.setValue(textoActual);
    }
  }
  
  //permitir lo mismo pero en el drop
  @HostListener('drop', ['$event']) ondrop($event) {
    // obtener texto actual
    let textoActual = $event.target.value;
    let textoPegado;
    if (this.solonumerosenteros) {
      //obtener el texto pegado del evento dragevent
      textoPegado = $event.dataTransfer.getData("text");
      
      // solo numeros y letras
      let textoFiltrado: String = textoPegado.replace(/[^\d]+/g, '');
      //evitar que se pegue el texto original
      $event.preventDefault();
      // agregar texto filtrado al texto actual
      textoActual += textoFiltrado;
      //verificar que no sobrepase el maxlength
      let maxlength = this.el.nativeElement.attributes['maxlength'];
      if (maxlength != undefined) {
        textoActual = textoActual.substring(0, maxlength.value);
      }

      // actualizar valor actual del texto
      this.model.control.setValue(textoActual);
    }
  }

}